export const PERMS = {
    READ: 'costs.read',
    UPDATE: 'costs.update',
    DELETE: 'costs.delete',
    CREATE: 'costs.create',
}
